import { DependencySource } from '../../../../shared/vendoredDependencies';
import type { DependencyQueryWithFilters } from '../../../../shared/dependenciesV2';

import useDependencies from './useDependencies';

/**
 * Wrapper around useDependencies which enforces that the vendoredPath is set.
 * @param {string} locator - The locator of the project revision.
 * @param {string} vendoredPath - The vendored path to filter by.
 * @param {DependencyQueryWithFilters} params - The parameters for the query.
 */
export default function useVendoredDependencies(
  locator: string,
  vendoredPath: string,
  params: DependencyQueryWithFilters,
) {
  return useDependencies(locator, {
    ...params,
    sources: [DependencySource.Vendored],
    vendoredPath,
  });
}
